import { render } from "./Debugger.vue?vue&type=template&id=664e7f6e&ts=true"
import script from "./Debugger.vue?vue&type=script&lang=ts"
export * from "./Debugger.vue?vue&type=script&lang=ts"

import "./Debugger.vue?vue&type=style&index=0&id=664e7f6e&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__